module.exports = __webpack_public_path__ + "assets/img/精细运营.0dd60d10.jpg";